
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/search/[keyword]",
      function () {
        return require("private-next-pages/support/search/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/search/[keyword]"])
      });
    }
  